import { makeStyles, lighten } from '@material-ui/core'

import { lang } from '../../../../localization'

const useStyles = makeStyles((theme) => ({
  tableTitles: {
    width: '24.5%',
    position: 'absolute',
    left: 0,
    backgroundColor: theme.palette.background.default,
    zIndex: 1
  },
  skeleton: { height: 70 },
  fullRow: {
    width: '100%'
  },
  tableContent: {
    // overflowY: 'hidden',
    // overflowX: 'scroll',
    // scrollbarWidth: 'none',
    // '&::-webkit-scrollbar': {
    //   display: 'none'
    // }
    // boxShadow: `-10px 10px 10px ${theme.palette.grfey[500]} inset!important`
    position: 'relative'
  },
  circularProgress: {
    position: 'absolute',
    top: 'calc(50% - 32px)',
    left: 'calc(50vw - 32px)'
  },
  tableContainer: {
    width: '100%',
    overflowY: 'hidden',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    display: 'grid',
    gridTemplateColumns: '20fr 31fr',
    backgroundColor: theme.palette.background.default
    // boxShadow: `inset 3px 8px 5px ${theme.palette.grey[800]}`
  },
  filtersButton: {
    width: '100%',
    backgroundColor: theme.palette.grey[200],
    padding: 10,
    display: 'flex',
    color: theme.palette.primary.dark,
    '& p': {
      color: theme.palette.primary.dark
    },
    '& button:last-child': {
      borderLeft: `1px solid ${theme.palette.grey[700]}`
    }
  },
  filtersButtonForOneButtonOnly: {
    borderLeft: 'none',
    '& button:last-child': {
      borderLeft: 'none'
    }
  },
  bigDate: {
    width: 130,
    textAlign: 'center'
  },
  bigDateContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 70,
    backgroundColor: theme.palette.grey[200],
    width: '100%'
  },
  rowName: {
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 12
  },
  rowNameTitle: {
    flex: 1,
    marginLeft: 10
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%',
    height: 70,
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`
  },
  menuModal: {
    position: 'absolute',
    top: 0,
    width: '100%',
    left: 0,
    borderRadius: '0 0 20px 20px',
    bottom: 160,
    overflowY: 'hidden'
  },
  submenu: { fontSize: 12, color: theme.palette.text.secondary },
  rateplanRowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%',
    height: 70,
    marginBottom: 20,
    // backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`
  },
  channelRowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%',
    height: 70,
    backgroundColor: lighten(theme.palette.secondary.light, 0.7),
    borderBottom: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  channelArrowRightCollapsed: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  dateButtonContainer: {
    marginTop: 30,
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    color: theme.palette.primary.contrastText,
    '& p': {
      color: theme.palette.primary.contrastText
    }
  },
  filterButton: {
    padding: '2px 10px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  filterForMobileSize: {
    position: 'absolute',
    top: 60,
    width: '100%',
    left: 0,
    borderRadius: '20px 20px 0px 0px',
    bottom: 0,
    overflowY: 'hidden'
  },
  filterForMobileSizeModal: {
    backgroundColor: 'transparent',
    position: 'relative'
  },
  dateButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: 10
  },
  buttonContainer: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    padding: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.contrastText,
    '& p': {
      color: theme.palette.primary.contrastText
    },
    marginBottom: 24
  },
  root: {
    width: '100%',
    position: 'relative'
  }
}))
export default useStyles
